import ky, { HTTPError } from 'ky';
import type { Session } from '@stayon/auth-core';
import { classifyRefreshFailure } from '@/shared/api/refreshFailure';

async function postCookieRefresh(baseUrl: string, csrfToken: string): Promise<Session> {
  return ky
    .post(`${baseUrl}/api/v1/auth/refresh`, {
      credentials: 'include',
      headers: { 'X-CSRF-Token': csrfToken },
      timeout: 10_000,
      retry: 0,
    })
    .json<Session>();
}

export async function refreshCookieSession(baseUrl: string, csrfToken: string): Promise<Session> {
  try {
    return await postCookieRefresh(baseUrl, csrfToken);
  } catch (error) {
    if (classifyRefreshFailure(error).kind !== 'csrf-rejected') throw error;
    const csrf = await ky
      .get(`${baseUrl}/api/v1/auth/csrf`, {
        credentials: 'include',
        timeout: 10_000,
        retry: 0,
      })
      .json<{ csrfToken: string }>();
    return postCookieRefresh(baseUrl, csrf.csrfToken);
  }
}

/**
 * Abmelden beim Server; `true`, wenn er es bestätigt hat. Die lokale Sitzung endet in jedem Fall;
 * scheitert der Server, bleibt sein Refresh-Cookie bis zum Ablauf gültig — das steht im Protokoll
 * statt still zu verschwinden.
 */
export async function signOutAtServer(baseUrl: string): Promise<boolean> {
  try {
    await logoutCookieSession(baseUrl);
    return true;
  } catch (error) {
    console.warn('[auth] server logout failed', {
      status: error instanceof HTTPError ? error.response.status : 0,
      name: error instanceof Error ? error.name : typeof error,
    });
    return false;
  }
}

export async function logoutCookieSession(baseUrl: string): Promise<void> {
  const csrf = await ky
    .get(`${baseUrl}/api/v1/auth/csrf`, {
      credentials: 'include',
      timeout: 10_000,
      retry: 0,
    })
    .json<{ csrfToken: string }>();
  await ky.post(`${baseUrl}/api/v1/auth/logout`, {
    credentials: 'include',
    headers: { 'X-CSRF-Token': csrf.csrfToken },
    timeout: 10_000,
    retry: 0,
  });
}
